module.exports = __webpack_public_path__ + "img/store_result_empty.6a889ef.webp";